import _extends from "@babel/runtime/helpers/extends";
import cx from "classnames";
import React, { useCallback } from "react";
import { ToggleGroup } from "../ToggleGroup";
const defaultGetOptionLabel = option => option.label;
const defaultGetOptionValue = option => option.value;
/**
 * @deprecated Use ToggleGroup instead.
 */
export const RadioGroup = _ref => {
  let {
    className,
    disabled = false,
    getOptionLabel = defaultGetOptionLabel,
    getOptionValue = defaultGetOptionValue,
    name,
    onChange,
    options,
    value,
    variant,
    ...rest
  } = _ref;
  const handleChange = useCallback(value => {
    var _options$find;
    const selected = (_options$find = options.find(option => value === getOptionValue(option).toString())) !== null && _options$find !== void 0 ? _options$find : null;
    if (onChange) onChange(selected);
  }, [getOptionValue, onChange, options]);
  return /*#__PURE__*/React.createElement(ToggleGroup.Root, _extends({
    className: cx("TombacRadioGroup", className),
    disabled: disabled,
    groupContainerProps: {
      $width: "auto"
    },
    name: name,
    onChange: handleChange,
    value: value ? getOptionValue(value).toString() : undefined
  }, rest), options.map(option => {
    const label = getOptionLabel(option);
    const value = getOptionValue(option);
    return /*#__PURE__*/React.createElement(ToggleGroup.Item, {
      key: value,
      value: value.toString()
    }, label);
  }));
};
//# sourceMappingURL=RadioGroup.js.map